import { Component, OnInit, OnDestroy } from '@angular/core';
import { PrCmpa, ProductCmpaService } from '../../services/product-cmpa.service';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { Ng2TableModule } from 'ng2-table/ng2-table';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';
import { Subscription } from 'rxjs';
import { PermissionService } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { toast } from 'angular2-materialize';
import { UnitService, UnitId } from '../../services/unit.service';
import { FirestoreService } from '../../services/firestore/firestore.service';
import { CustomerSupplierId, CustomerSupplierService } from '../../services/customer-supplier.service';
import { Utils } from '../../util';
import { WarehouseService, WarehouseId } from '../../services/warehouse.service';

@Component({
  selector: 'app-read-pr-cmpa',
  templateUrl: './read-pr-cmpa.component.html',
  styleUrls: ['./read-pr-cmpa.component.css']
})
export class ReadPrCmpaComponent implements OnInit, OnDestroy {
  allowed: boolean = false;
  permission: any = {};

  prCmpas:any[] = [];
  units: {[unitId: string]: UnitId} = {};

	data:Array<any>;
  rows:Array<any> = [];
  columns:Array<any> = [
    {title: 'Nombre', name: 'name',sort: 'asc'},
    {title: 'Características', name: 'characsDescription'},
    {title: 'Unidad de compra', name: 'unitName'},
    {title: 'Clasificación' , name: 'class'},
    {title: 'Código', name: 'code'},
    {title: 'Último precio', name: 'lastPriceUsed'},
    { title: 'Acciones', className: 'center',  name: 'actionGroup', sort: false, actions: { type: 'group', buttons: [
			{ name: 'edit', title: '', styleIcon: 'edit', action: 'onEdit',
				styleClass: 'btn-floating btn waves-effect light-green darken-1' },
			{ name: 'delete', title: '', styleIcon: 'delete', action: 'onDelete',
				styleClass: 'btn-floating btn waves-effect red darken-2', }
		] } }
  ];
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config:any = {
    paging: true,
    sorting: {columns: this.columns},
    filtering: {filterString: ''},
		api: {
			onEdit: this.onEdit.bind(this),
			onDelete: this.onDelete.bind(this)
		}
  };

  subs: Subscription[] = [];

  constructor(
    private service: ProductCmpaService,
    private unitService: UnitService,
    private settings: CatalogsSettingsService,
		private permissionService: PermissionService,
    private authService: AuthService,
    private afh: FirestoreService,
    private supService: CustomerSupplierService,
    private wareService: WarehouseService,
    private router: Router
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
        permissionsSubs.unsubscribe();
        this.permission = this.permissionService.constructPermissionObject(groups, service.collection);
        if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
        else this.allowed = true;
    });

    this.subs.push(
      this.settings.getPayrollSettings('1').subscribe(setting => {
        this.itemsPerPage = setting.tableQuantity;
      })
    );
    let unitSub = this.unitService.getUnits().subscribe(units => {
      unitSub.unsubscribe();
      this.units = units.reduce((acc, cur) => ({...acc, [cur.id]: cur}), {});
      this.subs.push(
        this.service.getPrCmpas().subscribe(tempPrCmpas => {
          this.prCmpas = [];
          for (const idx in tempPrCmpas) {
            const {lastPriceUsed: lpu=0, ...u} = tempPrCmpas[idx];
            u.lastPriceUsed = lpu;
            u.class = u.data.name;
            u.unitName = u.unitRef ? this.units[u.unitRef.id].name : '';
            u.characsDescription = u.characs.reduce((acc, cur, index) => {
              let characs = `${acc}${index ? ', ' : ''}${cur.name.charAt(0)} ${cur.value}`;
              let {symbol = ''} = this.units[cur.unitId.id] || {};
              return `${characs}${symbol ? ` ${symbol}` : ''}`;
            }, '');
            this.prCmpas.push(u);
          }

          if(localStorage.re_prCmpa__page){
            this.page = +localStorage.re_prCmpa__page;
          }
          this.data = this.prCmpas;
          this.length = this.data.length;
          this.onChangeTable(this.config);
        })
      );
    });
  }

  ngOnInit() {
    
  }
  ngOnDestroy(){
    this.subs.map((sub, index) => {
      this.subs[index].unsubscribe();
    });
  }

  deletePrCmpa(sid: string) {
    this.service.deletePrCmpa(sid);
  }

  onCellClick(data: any): any {
		this.router.navigate(['/vw_prCmpa/' + data.row.id]);
  }

  onCreate(){
    if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
    this.router.navigate(['/new_prCmpa']);
  }

	onEdit(data: any) {
    if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);
		this.router.navigate(['/edit_prCmpa/', data.row.id]);
	}

	onDelete(data: any) {
    if(!this.permission.deleteAction) return toast('No tiene los permisos para eliminar.', 2000);
		this.deletePrCmpa(data.row.id);
  }

  async onExcel(){
    let {itemsPerPage, page} = this;
    this.itemsPerPage = this.data.length;
    this.page = 1;
    this.onChangeTable(this.config);

    let fsSuppliers = await this.afh.colWithIds<CustomerSupplierId>(this.supService.collection, ref => ref.where('typeId', '==', '3'));
    let suppliers: {[id: string]: CustomerSupplierId} = fsSuppliers.reduce((acc, cur) => ({...acc, [cur.id]: cur}), {});

    let fsWares = await this.afh.colWithIds<WarehouseId>(this.wareService.collection, ref => ref.where('active', '==', true));

    let headers = [
      {key: 'id', name: 'Id'},
      {key: 'stock', name: 'Existencia'},
      {key: 'name', name: 'Nombre'},
      {key: 'code', name: 'Código'},
      {key: 'class', name: 'Clasificación'},
      {key: 'description', name: 'Descripción'},
      {key: 'reorderQuantity', name: 'Cantidad de reorden'},
      {key: 'lastPriceUsed', name: 'Último precio'},
      {key: 'activeComponent', name: 'Componente activo'},
      {key: 'unitName', name: 'Unidad de compra'},
    ];
    let headersCharacs: typeof headers = [];
    let headersPrices: typeof headers = [];

    let rows = [];

    for(let i = 0; i < this.rows.length; i++){
      let row = {stock: 0};
      for(let header of headers){
        if(header.key == 'stock') continue;
        row[header.key] = this.rows[i][header.key] || '';
      }
      for(let charac of this.rows[i].characs){
        let key = `Valor ${charac.name}`, name = key;
        let {symbol = ''} = this.units[charac.unitId.id] || {};
        row[key] = `${charac.value}${symbol ? ` ${symbol}` : ''}`;
        //console.log(this.rows[i].id, key, row[key], row);
        if(!headersCharacs.find(header => key == header.key)) headersCharacs.push({key, name});
      }
      for(let price of this.rows[0].prices){
        let {name: supName = ''} = suppliers[price.supplierId.id] || {};
        let key = `Precio ${supName}`, name = key;
        row[key] = `${price.price}`;
        if(!headersPrices.find(header => key == header.key)) headersPrices.push({key, name});
      }
      for(let ware of fsWares){
        row.stock += +(ware.products.find(pr => pr.ref.id == this.rows[i].id) || {quantity: 0}).quantity || 0;
      }
      row.stock = +row.stock.toFixed(4);
      rows.push(row);
    };

    let allHeaders = [...headers, ...headersCharacs, ... headersPrices];
    let strRows = [allHeaders.map(({name}) => name)];

    for(let row of rows){
      let columns: string[] = [];
      for(let header of allHeaders){
        columns.push(row[header.key] ? `${row[header.key]}` : '');
      }
      strRows.push(columns);
    }
    
    Utils.downloadExcel(strRows, `Productos_de_compra_${Utils.today.replace(/-/g, '')}`);
    this.itemsPerPage = itemsPerPage;
    this.page = page;
    this.onChangeTable(this.config);
  }
  
  /*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
		localStorage.re_prCmpa__page = `${page.page}`;
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columns.forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columns.forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

}
